module.exports = __webpack_public_path__ + "static/img/office (3).c79b059c.jpg";